/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Edit = defineComponent({
  name: "Edit",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Edit.install = function (app) {
  app.component(Edit.name, Edit);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M30.9063 11.8946L33.9236 8.87737L39.1231 14.0768L36.1417 17.0581L30.9063 11.8946ZM28.0778 14.7231L10.69 32.1105L8.66027 39.3396L15.8896 37.3099L33.3132 19.8866L28.0778 14.7231ZM41.9831 11.2799L36.7205 6.01736C35.1758 4.47272 32.6714 4.47273 31.1268 6.01737L7.49171 29.652L7.12179 30.0219L6.98037 30.5256L4.31707 40.0111C3.68886 42.2484 5.75142 44.311 7.98881 43.6828L17.4745 41.0196L17.9781 40.8782L18.3481 40.5082L41.9831 16.8737C43.5278 15.329 43.5278 12.8245 41.9831 11.2799Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Edit.render = render;

export { Edit as default };
